"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LazyPicture;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useImageLoading = require("../hooks/use-image-loading.js");
var _react2 = require("@linaria/react");
const Image = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "Image",
  class: "core-icc1n5l",
  vars: {
    "icc1n5l-0": [({
      aspectRatio = 1
    }) => aspectRatio]
  }
});

/**
 * LazyPicture
 *
 * @param {Object} props props
 * @param {String} props.src Image Source
 * @param {String} props.alt Image Alt Text
 * @param {Number} props.height image height
 * @param {Number} props.width image width
 * @param {String} props.dataCy image data-cy
 * @param {Boolean} props.show image in view boolean
 * @param {String} props.rootMargin root margin for useInView
 * @param {Number} props.threshold threshold for useInView
 * @returns {React.ReactFragment} LazyPicture Component
 * @public
 */

function LazyPicture({
  defaultSrc,
  defaultAltText = '',
  children: otherSources,
  loading = 'lazy',
  dataCy,
  show = false,
  rootMargin = '100px 0px',
  threshold = 0,
  ...rest
}) {
  const {
    ref,
    getImageSrc
  } = (0, _useImageLoading.useImageLoading)({
    loading,
    rootMargin,
    threshold,
    initialInView: false,
    show
  });
  return /*#__PURE__*/_react.default.createElement("picture", {
    ref: ref,
    "data-cy": "lazy-picture"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, otherSources, /*#__PURE__*/_react.default.createElement(Image, (0, _extends2.default)({}, rest, {
    aspectRatio: rest?.width / rest?.height
  }, getImageSrc(defaultSrc), {
    alt: defaultAltText,
    role: "presentation",
    "data-cy": dataCy
  }))));
}
LazyPicture.propTypes = {
  defaultSrc: _propTypes.default.string,
  defaultAltText: _propTypes.default.string,
  children: _propTypes.default.node,
  loading: _propTypes.default.oneOf(['lazy', 'eager', 'manual']),
  dataCy: _propTypes.default.string,
  show: _propTypes.default.bool,
  rootMargin: _propTypes.default.string,
  threshold: _propTypes.default.oneOf([_propTypes.default.number, _propTypes.default.array])
};